import { render, staticRenderFns } from "./RegulatorManager.vue?vue&type=template&id=28433ce9&"
import script from "./RegulatorManager.vue?vue&type=script&lang=ts&"
export * from "./RegulatorManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports